<div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start space-between">
  <div class="row">
    <mat-icon class="msg-box-icon">{{getIcon()}}</mat-icon>
  </div>
  <div class="row">
    <span class="msg-box-message">{{data.data.Type}} Alert From: {{sensor.name}}</span>
  </div>
  <span fxFlex></span>

  <div class="row">
    <button class="small-button" mat-stroked-button (click)="openAlertWindow()"
      [matTooltip]="'Open Alerts Window'">
      <mat-icon class="svg-icon">touch_app</mat-icon>
    </button>
    <button class="small-button" mat-stroked-button (click)="onBtnClick()" [matTooltip]="'Close'">
      <mat-icon class="svg-icon">clear</mat-icon>
    </button>
  </div>
</div>